import { render, staticRenderFns } from "./param-bind-proxy-form-items.vue?vue&type=template&id=7340c616&scoped=true&"
import script from "./param-bind-proxy-form-items.vue?vue&type=script&lang=ts&"
export * from "./param-bind-proxy-form-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7340c616",
  null
  
)

export default component.exports